"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(palette) {
  return {
    palette: palette,
    color: palette.tFilled,
    listBackground: palette.elPrimary,
    listBoxShadow: "0 6px 10px 0 ".concat(palette.elShadow, ", 0 4px 10px 0 ").concat(palette.elShadow),
    listZIndex: palette.zOverlay,
    itemColor: palette.tFilled,
    itemBackground: 'transparent',
    itemPaddingBottom: palette.gutter + 'px',
    itemPaddingTop: palette.gutter + 'px',
    itemPaddingLeft: palette.gutter * 2 + 'px',
    itemPaddingRight: palette.gutter * 2 + 'px',
    focusItemColor: palette.tFilled,
    focusItemBackground: 'transparent',
    hoverItemColor: palette.tFilled,
    hoverItemBackground: palette.elLightest,
    activeItemColor: palette.tActive,
    activeItemBackground: palette.elLightest
  };
}